// extracted by mini-css-extract-plugin
module.exports = {"page_wrapper":"PageContentLayout_page_wrapper__3GQap","page_content":"PageContentLayout_page_content__2Lvlv","page_footer":"PageContentLayout_page_footer__Du5FG"};